<docs>
  This area is top center 3 icons, views, likes and comments icons
</docs>

<template>
  <div
    v-if="!isEmpty(social) && !isUiMode"
    class="social"
  >
    <a
      v-if="isShowView"
      role="button"
      class="social-item inline-flex-center"
    >
      <i class="isif isif-view social-icon" />
      <span>{{ social[icon.view.count] }}</span>
    </a>
    <a
      v-if="isShowLike"
      role="button"
      class="social-item inline-flex-center clickable"
      :class="{ 'active': isSocialLiked }"
      @click="updateLikeCount"
    >
      <i class="isif isif-like social-icon" />
      <span>{{ social[icon.like.count] }}</span>
    </a>
    <a
      v-if="isShowComment"
      role="button"
      class="social-item inline-flex-center clickable"
      :class="{ 'active': isCommentsActive }"
      @click="clickComments"
    >
      <i class="isif isif-comment social-icon" />
      <span>{{ social[icon.comment.count] }}</span>
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { SOCIAL } from '~js/constants'
import { isEmpty, isIframe } from '~js/utils'
import queryString from '../../../api/query-string'

export default {
  name: 'SocialIndex',
  data () {
    return {
      icon: {
        view: {
          name: 'view',
          count: SOCIAL.VIEW_COUNT
        },
        like: {
          name: 'like',
          count: SOCIAL.LIKE_COUNT
        },
        comment: {
          name: 'comment',
          count: SOCIAL.COMMENT_COUNT
        }
      }
    }
  },

  computed: {
    ...mapGetters([
      'isCommentsActive',
      'isSocialLiked',
      'isUiMode',
      // 'mainColor',
      'showComment',
      'social'
    ]),

    isShowView () {
      return !queryString.hideViewNum
    },

    isShowLike () {
      return !queryString.hideLike
    },

    isShowComment () {
      if (this.showComment) {
        if (isIframe()) return queryString.showComment
        if (queryString.hideComment) return false
        return true
      }
      return false
    }
  },

  methods: {
    ...mapActions([
      'closeInformation',
      'closeLocation',
      'closeMarkerInfo',
      'closeShare',
      'toggleComments',
      'updateLikeCount'
    ]),

    clickComments () {
      this.toggleComments()
      this.closeInformation()
      this.closeShare()
      this.closeMarkerInfo()
      this.closeLocation()
    },

    isEmpty (data) {
      return isEmpty(data)
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.social {
  pointer-events: auto
  font-size: 14px
  margin-top: 0.9375rem
}

.social-item {
  cursor: default;
  display: flex;
  align-items: center;

  &.clickable {
    cursor: pointer;
  }

  & + & {
    margin-left: $social-index-social-item-margin
  }

  &.active {
    .social-icon {
      color: $pink-color;
    }
  }
}

.social-icon {
  margin-right: $social-index-social-icon-margin
  font-size: 20px;
  color: white;
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

.theme-rtl.theme-rtl-overlap {
  .social-icon {
    margin-right: auto
    margin-left: $social-index-social-icon-margin
  }

  .social-item + .social-item {
    margin-left: auto
    margin-right: $social-index-social-item-margin
  }
}
</style>
